import { Component, HostListener, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AuthService } from '../../services/auth';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  protected readonly appName = 'Gamma Ray Normalization';
 protected readonly auth = inject(AuthService);
  protected userName = '';
  protected userInitials = '';
  protected readonly isAdmin = signal(false);
  protected menuOpen = false;

  ngOnInit(): void {
    this.userName = this.auth.getUserName();
    this.userInitials = this.computeInitials(this.userName);
    this.auth.isAdmin().subscribe((isAdmin) => this.isAdmin.set(isAdmin));
  }

  protected toggleMenu(event: MouseEvent): void {
    event.stopPropagation();
    this.menuOpen = !this.menuOpen;
  }

  @HostListener('document:click')
  protected closeMenu(): void {
    this.menuOpen = false;
  }

  protected logout(): void {
    this.auth.logout();
  }

  private computeInitials(name: string): string {
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) {
      return '';
    }

    const first = parts[0].charAt(0);
    const last = parts.length > 1 ? parts[parts.length - 1].charAt(0) : '';
    return `${first}${last}`.toUpperCase();
  }
}
